export const PROJECT_MAIN_CELL_WIDTH = 240; // px
export const PROJECT_CELL_VERTICAL_PADDING = '0.25em .65em';
